<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Your Donation">
                    <div>
                        <AmountSelector/>
                        <ErrorLabel field="amount" />
                    </div>
                </FormSection>
                <FormSection v-if="form.amount">
                  <TransactionFee />
                </FormSection>
                <FormSection title="Contact Info">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                    </FormRow>
                </FormSection>
                <FormSection title="Billing Details">
                    <DonorAddress />
                    <FormCol field="phone" width="half"/>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
                </FormSection>
                <FormSection title="" last>
            <FormRow>
              <Receipt />
            </FormRow>                     
                    <FormCol field="card" :showLabel="false"/>
                </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup() {
    const { form, submit, setValue } = usePaymentForm()

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
input[type="checkbox"] {
  margin-right:5px;
}
::v-deep .radio-part {
    min-width: 31.33333% !important;
    max-width: 31.33333% !important;
    &:nth-child(3n) {
      padding-right: 0 !important;
    }
}
::v-deep .amount_other__wrapper {
  max-width: 29.666% !important;
}
::v-deep label {
  position: relative;
}
::v-deep .styled-radio--ou-donation.styled-radio label[for="amount72"] {
  background: #f3f5f8;
  padding-bottom: 22px;
}
::v-deep .styled-radio--ou-donation.styled-radio label[for="amount100"] {
    padding-bottom: 22px;
    background-color: #d1defb;
}
::v-deep label[for="amount108"]:before{
    content: "minimum for membership";
    display: block;
    font-size: 12px;
    position: absolute;
    bottom: 2px;
    padding: 4px;
    width: 100%;
    font-weight: normal;
}
::v-deep label[for="amount100"]:before {
  content: "most common";
}
</style>

